import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRepeat = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 21,
	viewBox: "0 0 19 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "replay",
		d: "M9.36009 20.8529C8.15366 20.8529 7.02292 20.6259 5.96788 20.1719C4.91284 19.7179 3.99097 19.0966 3.20227 18.3079C2.41357 17.5192 1.79223 16.5973 1.33823 15.5423C0.884226 14.4872 0.657227 13.3565 0.657227 12.15H1.74508C1.74508 14.2714 2.48392 16.0709 3.9616 17.5485C5.43927 19.0262 7.23877 19.765 9.36009 19.765C11.4814 19.765 13.2809 19.0262 14.7586 17.5485C16.2363 16.0709 16.9751 14.2714 16.9751 12.15C16.9751 10.0287 16.2363 8.22922 14.7586 6.75154C13.2809 5.27387 11.4814 4.53503 9.36009 4.53503H8.94589L10.7158 6.30498L9.9459 7.08742L6.84959 3.97016L9.98779 0.852905L10.7574 1.63535L8.94589 3.44718H9.36009C10.5665 3.44718 11.6973 3.67417 12.7523 4.12817C13.8073 4.58217 14.7292 5.20352 15.5179 5.99222C16.3066 6.78092 16.928 7.70279 17.382 8.75783C17.836 9.81287 18.063 10.9436 18.063 12.15C18.063 13.3565 17.836 14.4872 17.382 15.5423C16.928 16.5973 16.3066 17.5192 15.5179 18.3079C14.7292 19.0966 13.8073 19.7179 12.7523 20.1719C11.6973 20.6259 10.5665 20.8529 9.36009 20.8529Z",
		fill: "currentColor",
		style: { fillOpacity: 1 }
	})
});
export default SvgRepeat;
